import { render } from "./Ayuda.vue?vue&type=template&id=0bb10eef"
import script from "./Ayuda.vue?vue&type=script&lang=js"
export * from "./Ayuda.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\RE ALIMAS\\alimasweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__